import React from "react";
import { LongTextLabel } from "@sscs/ui";
import { Dialog } from "Components";
import { Member } from "Types";
import useResendInvite from "./useResendInvite";

type ResendMemberInviteProps = {
  member: Member;
  isOpen: boolean;
  onClose: () => void;
};

const ResendInvite = ({
  member,
  isOpen,
  onClose,
}: ResendMemberInviteProps): React.JSX.Element | null => {
  const { handleResend } = useResendInvite(member, onClose);

  return (
    <Dialog
      title="Resend member invite"
      confirmText="Resend invite"
      isOpen={isOpen}
      onCancel={onClose}
      onClose={onClose}
      onConfirm={handleResend}
    >
      <div>
        Are you sure you want to resend invite to{" "}
        <b>
          <LongTextLabel label={member.email} maxCharacters={100} inline />
        </b>
        ?
      </div>
    </Dialog>
  );
};

export default ResendInvite;
